import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { pathFromLocationState } from '../utils/authRedirect';

const Signup: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { signup } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError('Those passwords do not match.');
      return;
    }

    try {
      setError('');
      setLoading(true);
      await signup(email, password, displayName);
      navigate(pathFromLocationState(location.state) || '/', { replace: true });
    } catch (err: any) {
      setError(err.message || 'Could not create an account.');
      console.error('Signup error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ss-sheet ss-auth">
      <p className="ss-kicker">Spin &amp; Solve</p>
      <h1 className="ss-title">Create an account</h1>
      <p className="ss-sub">A name, email, and password. That’s enough to host a room.</p>

      {error && (
        <div className="ss-error" role="alert">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <label htmlFor="displayName" className="ss-label">
          Display name
        </label>
        <input
          type="text"
          id="displayName"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          className="ss-input"
          required
          autoComplete="nickname"
          placeholder="Pat"
        />

        <label htmlFor="email" className="ss-label">
          Email
        </label>
        <input
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="ss-input"
          required
          autoComplete="email"
          placeholder="you@example.com"
        />

        <label htmlFor="password" className="ss-label">
          Password
        </label>
        <input
          type="password"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="ss-input"
          required
          minLength={6}
          autoComplete="new-password"
          placeholder="At least 6 characters"
        />

        <label htmlFor="confirmPassword" className="ss-label">
          Confirm password
        </label>
        <input
          type="password"
          id="confirmPassword"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          className="ss-input"
          required
          autoComplete="new-password"
          placeholder="Type it again"
        />

        <button type="submit" disabled={loading} className="ss-btn ss-btn-primary" style={{ width: '100%' }}>
          {loading ? 'Creating account' : 'Create account'}
        </button>
      </form>

      <div className="ss-auth-links">
        <p className="ss-who">
          Already have an account?{' '}
          <Link to="/login" state={location.state} className="ss-inline-link" style={{ marginTop: 0 }}>
            Log in
          </Link>
        </p>
        <Link to="/" className="ss-inline-link">
          Back home
        </Link>
      </div>
    </div>
  );
};

export default Signup;
